import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledBoxText,
  StyledText,
  StyledParagraph,
  StyledAuthor
} from './style';

const BoxText = ({ className, title, paragraph, author }) => (
  <StyledBoxText className={className}>
    <StyledText>{title}</StyledText>
    <StyledParagraph>{paragraph}</StyledParagraph>
    <StyledAuthor>{author}</StyledAuthor>
  </StyledBoxText>
);

BoxText.propTypes = {
  className: PropTypes.string
};

BoxText.defaultProps = {};

export default BoxText;
